export const ADD_POST = 'ADD_POST'
export const ADD_POST_DETAIL = 'ADD_POST_DETAIL'